import type { SnsAccount, SnsProfile } from '../Module/Auth/Domain/entity/AuthTypes';

/** 카카오 인가 요청에 넣은 state 를 콜백에서 확인하기 위한 sessionStorage 키 */
export const SNS_STATE_STORAGE_KEY = 'missionfund.snsLoginState';

/**
 * SNS 인증 뒤 로그인 화면으로 넘기는 값 (location.state.sns)
 * - 계정 선택·이메일 로그인(연결)·회원가입에 ticket 을 함께 보낸다
 */
export type SnsLoginState = {
  ticket: string;
  accounts: SnsAccount[];
  profile: SnsProfile;
  /** 글로벌 ID (없으면 null) */
  gid?: string | null;
};

/** 로그인 화면 → 회원가입 화면으로 넘기는 값 (location.state.snsSignup) */
export type SnsSignupState = {
  ticket: string;
  profile: SnsProfile;
};

/**
 * 계정 선택 목록에 표시할 이름 — `이름(단체명)`
 * - 이름·단체명 중 하나만 있으면 있는 값만, 둘 다 없으면 이메일
 */
export const getSnsAccountLabel = (account: SnsAccount): string => {
  const name = (account.name ?? '').trim();
  const organization = (account.organization ?? '').trim();
  if (name && organization) return `${name}(${organization})`;
  return name || organization || account.email;
};

/** AuthRepositoryImpl 이 만든 오류 메시지(`SNS_{result_Code}[:상세]`)에서 result_Code 를 꺼낸다 */
export const getSnsErrorCode = (message?: string | null): number | undefined => {
  const match = /^SNS_(\d+)/.exec(message ?? '');
  return match ? Number(match[1]) : undefined;
};

/** 티켓이 만료·위조되어 SNS 인증부터 다시 해야 하는 오류 */
export const SNS_TICKET_INVALID_CODE = 40041;
